<template>
    <alzata-icon class="d-print-none" :icon="icon" />
</template>

<script>
export default {
    name: 'AlzataSortIndicator',
    props: {
        order: {},
        columnId: String,
    },
    computed: {
        icon() {
            if (this.order.column !== this.columnId) {
                return 'fas/sort';
            }
            return this.order.dir === 'asc' ? 'fas/sort-up' : 'fas/sort-down';
        },
    },
};
</script>